module.exports = __webpack_public_path__ + "fe725901338e5651e1429ef0b241538a.svg";